export const UnitModeEnum = Object.freeze({
    ONE_FLOW: 'oneflow',
    PAGE_BY_PAGE: 'pagebypage'
});

export const FormatModeEnum = Object.freeze({
    BRAILLE_VIEW: 'brailleview',
    NORMAL_VIEW: 'normalview'
});

export const CookieEnum = Object.freeze({
    ALLOWED: 'allowed',
    DENIED: 'denied'
});

export const FileLoadStatusEnum = Object.freeze({
    INITIAL: 'initial',
    LOADING: 'loading',
    FAILED: 'failed',
    SUCCESSFUL: 'successful'
});
